export default {"src":"/_next/static/media/NPR.167c48dd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};